"use client"

import Hero from "./Hero"

type Props = {}

const Home = ({}: Props) => {
  return <Hero />
}

export default Home
